module.exports = __webpack_public_path__ + "static/media/helvetia_logo_it.23710831.svg";